import angular from 'angular';
import { filter } from 'lodash';

module.exports = angular.module('common.services.dropdown_label', [])
.factory('dropdownLabel', function() {
  return function dropdownLabel(setFilter, options) {
    var active = filter(options, function(option) {
      return setFilter[option.value];
    });

    switch (active.length) {
      case 0:
      case options.length:
        return 'Any';
      case 1:
        return active[0].name;
      default:
        return 'Multiple…';
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/dropdown_label.js
 **/